import { Directive, ElementRef, HostBinding, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription, interval } from 'rxjs';

import { WindowRef } from '../window-ref';

@Directive({
  selector: '[verticalPos]',
})
export class VerticalPosDirective implements OnInit, OnDestroy {
  private el = inject<ElementRef<HTMLElement>>(ElementRef);
  private winRef = inject(WindowRef);

  private win = this.winRef.nativeWindow;
  @HostBinding('class.vertical-pos-top') top = false;
  @HostBinding('class.vertical-pos-middle') middle = false;
  @HostBinding('class.vertical-pos-bottom') bottom = false;

  private sub = new Subscription();

  ngOnInit(): void {
    interval(500).subscribe(() => this.topMiddleBottom());
  }

  topMiddleBottom() {
    const perc = Math.trunc((this.el.nativeElement.getBoundingClientRect().top / this.win.innerHeight) * 100);
    this.top = perc < 33;
    this.bottom = perc > 66;
    this.middle = !(this.top || this.bottom);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
